export default __webpack_public_path__ + "static/media/doctors.3ac47acb.svg";